/**
 * Site offline (api-tracker 5.1.0, typé localement tant que le client n'est pas publié) : une
 * config de ville créée dans l'app mobile et poussée au tracker en BLE, inconnue du serveur.
 * `Tracker.site` reste le dernier site serveur ; `Tracker.offlineSite` est absent/null hors site
 * offline.
 */
export interface TrackerOfflineSite {
  name: string;
  configId?: number | null;
  /** ISO-8601. */
  since: string;
}

/** Code du 409 renvoyé par trackermanager pour toute action bloquée tant que le tracker est en site offline. */
export const OFFLINE_SITE_CONFLICT_CODE = 'TRACKER_ON_OFFLINE_SITE';

/**
 * Site offline porté par un tracker, ou null. Accepte n'importe quel objet (Tracker inside,
 * IntegratorTracker…) : le champ n'existe pas encore dans les clients générés.
 */
export function offlineSiteOf(tracker: unknown): TrackerOfflineSite | null {
  if (!tracker || typeof tracker !== 'object') return null;
  const site = (tracker as { offlineSite?: unknown }).offlineSite;
  if (!site || typeof site !== 'object') return null;
  return typeof (site as TrackerOfflineSite).name === 'string' ? (site as TrackerOfflineSite) : null;
}

export function isOnOfflineSite(tracker: unknown): boolean {
  return offlineSiteOf(tracker) !== null;
}

/** Vrai pour une HttpErrorResponse 409 `{ code: 'TRACKER_ON_OFFLINE_SITE' }`. */
export function isOfflineSiteConflict(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const { status, error } = err as { status?: unknown; error?: unknown };
  if (status !== 409 || !error || typeof error !== 'object') return false;
  return (error as { code?: unknown }).code === OFFLINE_SITE_CONFLICT_CODE;
}
